import { render, staticRenderFns } from "./Theme4Section5.vue?vue&type=template&id=2535406d&scoped=true&"
import script from "./Theme4Section5.vue?vue&type=script&lang=js&"
export * from "./Theme4Section5.vue?vue&type=script&lang=js&"
import style0 from "./Theme4Section5.vue?vue&type=style&index=0&id=2535406d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2535406d",
  null
  
)

export default component.exports